import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useSelector } from "react-redux";
import { useAddAssignmentMarkMutation } from "../../../features/assignmentMark/assignmentMarkAPI";
import TextField from "../../form/TextField";
import ErrorMessage from "../../ui/ErrorMessage";

const darkModeStyles = {
  content: {
    background: "#333",
    color: "#fff",
    borderRadius: "10px",
    padding: "20px",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
  closeButton: {
    color: "#fff",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    position: "absolute",
    top: "10px",
    right: "10px",
    fontSize: "24px",
  },
  input: {
    background: "#555",
    color: "#fff",
    borderRadius: "5px",
    padding: "5px",
    border: "none",
    marginBottom: "10px",
    width: "100%",
  },
  label: {
    display: "block",
    marginBottom: "5px",
  },
  button: {
    background: "#ccc",
    color: "#333",
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
  },
};

function AssignmentSubmissionForm({ isModalOpen, setIsModalOpen, title }) {
  const [formValues, setFormValues] = useState({});
  const preparedPayload = useSelector(
    (state) => state.coursePlayer.assignmentMarkPayload
  );

  const [addAssignmentMark, { isLoading, isError, isSuccess }] =
    useAddAssignmentMarkMutation();
  function handleChange(event) {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  }

  function handleSubmit(event) {
    event.preventDefault();
    const payload = {
      ...preparedPayload,
      ...formValues,
      createdAt: new Date().toLocaleString(),
    };

    addAssignmentMark(payload);
  }

  useEffect(() => {
    if (isSuccess) {
      setIsModalOpen(false);
      setFormValues({});
    }
  }, [isSuccess, setIsModalOpen]);
  return (
    <ReactModal
      isOpen={isModalOpen}
      onRequestClose={setIsModalOpen}
      contentLabel="Form Modal"
      ariaHideApp={false}
      style={darkModeStyles}
    >
      <div
        className="modal-header"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <h3 className="center">
          Submit Assignment:
          <br /> {title || "N/A"}
        </h3>
        <button
          onClick={() => {
            setIsModalOpen(false);
          }}
        >
          ❌
        </button>
      </div>
      <div className="max-w-md  mt-8">
        <form className="space-y-6" onSubmit={handleSubmit}>
          <TextField
            id="repo_link"
            label="Repository Link"
            type="url"
            required
            value={formValues?.repo_link}
            onChange={handleChange}
          />
          <div
            style={{
              display: "grid",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {isError && <ErrorMessage />}
            <button
              type="submit"
              className="btn btn-primary text-slate-600"
              style={{
                padding: "0.5rem 2rem",
                marginTop: "0.5rem",
                width: "fit-content",
              }}
              disabled={isLoading}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </ReactModal>
  );
}

export default AssignmentSubmissionForm;
